module.exports = __webpack_public_path__ + "static/media/UK-Manchester.8852d3b1.png";